import { ThreadListItemSkeleton } from "@/component/ThreadListItem/skeleton";

interface ThreadListSkeletonGridProps {
  count?: number;
}

export function ThreadListSkeletonGrid(props: ThreadListSkeletonGridProps) {
  const { count = 4 } = props;

  return (
    <div className="grid-thread">
      {Array.from({ length: count }).map((_, idx) => (
        <ThreadListItemSkeleton key={idx} />
      ))}
    </div>
  );
}
